// @ts-nocheck

import React, { useMemo } from 'react';
import styled from 'styled-components';

import theme from '../../../../styled-components/dark';

const padNumber = (nb: number) => `0${nb}`.slice(-2);

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  font-family: 'BettingArchivoNarrow';
  white-space: nowrap;
`;

const Text = styled.div`
  font-size: 1.1em;
  text-align: center;
`;

const Row = styled.div`
  display: flex;
`;

const TimeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const TimeNumber = styled.div`
  display: flex;
  align-items: center;
  margin: 0.4em 0;
`;

const TimeDigit = styled.div`
  background: #dddddd66;
  padding: 0.15em 0.28em;
  margin: 0.1em;

  color: ${theme.KLNotification.highlightColor};
  font-size: 2.2em;
  font-weight: bold;
`;

const TimeUnit = styled.div`
  text-transform: uppercase;
  font-size: 0.8em;
`;

const Separator = styled.div`
  margin: 0.07em;
  font-size: 2em;
  font-weight: bold;
`;

type KLPoleTimerProps = {
  className?: string;
  time: number;
};

const KLPoleTimer = ({ className, time }: KLPoleTimerProps) => {
  const hours = useMemo(() => Math.trunc(time / 60), [time]);
  const minutes = useMemo(() => time - hours * 60, [time, hours]);

  return (
    <Wrapper className={className}>
      <Text>Temps passé sur les poteaux</Text>
      <Row>
        <TimeWrapper>
          <TimeNumber>
            {padNumber(hours)
              .split('')
              .map((digit, i) => (
                <TimeDigit key={`timer-hours-digit-${i}`}>{digit}</TimeDigit>
              ))}
            <Separator>:</Separator>
          </TimeNumber>
          <TimeUnit>heures</TimeUnit>
        </TimeWrapper>
        <TimeWrapper>
          <TimeNumber>
            {padNumber(minutes)
              .split('')
              .map((digit, i) => (
                <TimeDigit key={`timer-mins-digit-${i}`}>{digit}</TimeDigit>
              ))}
          </TimeNumber>
          <TimeUnit>minutes</TimeUnit>
        </TimeWrapper>
      </Row>
    </Wrapper>
  );
};

export default KLPoleTimer;
